// Conversão de escala PAP ↔ RTO para tags de otimização.
//
// O PAP exibe valores em escala amigável (% para frações, Celsius para temperatura);
// o RTO opera em escala interna (fração 0-1, Kelvin). A tradução acontece aqui.
//
// Usado por RtoConfigDrawer (bounds), RtoAssistentModal (resultado otimizado) e
// qualquer outro consumidor que precise traduzir valores entre as duas escalas.

// Espelho de DialogReadOnly.percentageProperty — atributos exibidos em % no PAP.
const PERCENTAGE_ATTRS = [
  'fracaoMassica', 'brix', 'brixSaida', 'Saida', 'brixAcucar', 'brixMel',
  'tx_agua', 'artTorta', 'pureza', 'purAcucar', 'purMel', 'xSolidosNaoFibraTorta',
  'TR', 'f_C', 'P_FT', 'X', 'eficienciaSeparacao', 'K', 'RecuperacaoEtanol',
  'xflegmaca', 'xhidratado', 'fmEtanol', 'Tx_L', 'umidadeC6', 'vmC',
];

// Espelho de ConvertValues.PropertyTemperature (PGDI Core + RTO) — atributos em Celsius no PAP.
const TEMPERATURE_ATTRS = [
  'T', 'TSaida', 'TSaidaFluido1', 'TSaidaFluido2', 'TSaidaVapor', 'TEtanol',
  'TVinhaca', 'Ts', 'TCondensador', 'TFlegmaca', 'Fusel', 'TAlcoolSegunda',
  'TFlegma', 'Tf', 'T0_W', 'Tr', 'TCaldo', 'T4',
];

// Operações isentas de conversão de temperatura — espelho do notAllowOperations
// em AbstractGenerateMappingBase (T já vem em Kelvin direto no XML dessas operações).
const TEMPERATURE_EXCLUSION_OPS = ['Desaerador', 'Turbina', 'TurbinaD'];

// Caso especial: Terra/fracaoMassica em 1_1 tem escala /1000 (PropertyBrix /100 + regra do P.O. /10).
function isTerraIn1_1(mapping) {
  if (!mapping) return false;
  const parts = mapping.split('|');
  return parts.length === 4
      && parts[0] === 'cp'
      && parts[1] === '1_1'
      && parts[2] === 'Terra'
      && parts[3] === 'fracaoMassica';
}

function isPercentageAttribute(mapping) {
  if (!mapping) return false;
  const parts = mapping.split('|');
  return PERCENTAGE_ATTRS.includes(parts[parts.length - 1]);
}

function isTemperatureAttribute(mapping) {
  if (!mapping) return false;
  const parts = mapping.split('|');
  if (!TEMPERATURE_ATTRS.includes(parts[parts.length - 1])) return false;
  // Operações Desaerador/Turbina/TurbinaD têm T direto em Kelvin no XML — sem conversão.
  if (parts[0] === 'op' && TEMPERATURE_EXCLUSION_OPS.includes(parts[1])) return false;
  return true;
}

// PAP scale (%, Celsius) → RTO scale (fração, Kelvin).
export function toRtoScale(value, mapping) {
  if (value == null) return value;
  if (isTerraIn1_1(mapping)) return value / 1000;
  if (isPercentageAttribute(mapping)) return value / 100;
  if (isTemperatureAttribute(mapping)) return value + 273.15;
  return value;
}

// RTO scale (fração, Kelvin) → PAP scale (%, Celsius).
export function fromRtoScale(value, mapping) {
  if (value == null) return value;
  if (isTerraIn1_1(mapping)) return value * 1000;
  if (isPercentageAttribute(mapping)) return value * 100;
  if (isTemperatureAttribute(mapping)) return value - 273.15;
  return value;
}
